import { Component, EventEmitter, input, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ArtikelMenge } from '../../types/artikel-menge';
import { ArtikelMengeComponent } from '../artikel-menge/artikel-menge.component';

import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-artikel-menge-auswahl',
  imports: [ArtikelMengeComponent,
    TranslatePipe],
  templateUrl: './artikel-menge-auswahl.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./artikel-menge-auswahl.component.css'] })
export class ArtikelMengeAuswahlComponent implements OnInit {
  @Input() lagerplatzInhalt: ArtikelMenge[] | null | undefined;
  @Output() artikelMengeChange = new EventEmitter<ArtikelMenge>();

  showInvMenge = input<boolean>(false);

  constructor() {}

  ngOnInit(): void {}

  onSelect(artikelMenge: ArtikelMenge | undefined): void {
    if (!artikelMenge) return;
    this.artikelMengeChange.emit(artikelMenge);
  }
}
